import Image from "next/image"
import Typography from "../../reusable/Typography/Typography"
import Button from "../../reusable/components/Button"
import {filterUrl} from "../../filter/FilterUrl"
import urlParams from "../../../utility/UrlParams"
import {useTranslation} from "next-i18next"
import {useRouter} from "next/router"
import {CollectionName} from "../../../constants"
import React, {useContext, useState} from "react"
import DataContext from "../../../context/DataContext"
import {formatImageSrc} from "../../../strapi/strapiHelpers"
import {ModalContext} from "../../../context/ModalContext"
import LayoutContext from "../../../context/LayoutContext"
import BookAppointmentModalContent from "../../reusable/ModalsContent/BookAppointmentModalContent"
import AskAiAboutMbp from "../../reusable/AskAiAboutMbp"

const categoryTypes = {
	ai: "isAi",
	consultation: "isConsultation",
	link: "isCategoryWithLink",
	default: "isCategoryWithSlug"
}
function BrandWorldCategories() {
	const {t} = useTranslation()
	const router = useRouter()
	const {brandWorld} = useContext(DataContext)
	const {isMobile} = useContext(LayoutContext)
	const {setModalContent, openModal, openDrawer, closeModal} = useContext(ModalContext)
	const [isOpen, setIsOpen] = useState<boolean|null>(false)
	const handleMagnetBtnClick = (type, categorySlug, link = "") => {
		switch (type) {
			case categoryTypes.link:
				router.push(link)
				break
			case categoryTypes.consultation:
				setModalContent(<BookAppointmentModalContent closeModal={closeModal}/>)
				openModal()
				break

			case categoryTypes.ai:
				if (isMobile === true) {
					setIsOpen(true)
				} else {
					setModalContent(<AskAiAboutMbp

					/>)
					openDrawer()
				}

				break
			case categoryTypes.default:
				router.push(`${filterUrl({[urlParams.categories]: categorySlug}, urlParams.categories, categorySlug, CollectionName.BrandWorld, CollectionName.BrandWorld, brandWorld.brandSlug)}#products-listing`, null, {shallow: true})
				break
			default:
				router.push(link)
		}
	}

	return (
		<div style={{gap: "40px", maxWidth: "100%", overflowX: "auto"}}
			className=" d-flex container align-items-between hide-overflow-scrollbar justify-content-start justify-content-lg-center mb-4 ">
			{brandWorld?.brandCategories?.length ? brandWorld?.brandCategories?.map(({categoryImage, categoryImageMobile, subTitle, categoryBtnCta, title, categorySlug, type, href}, index) =>
				<div
					key={index}
					className="brand-world-categories">
					<div className="d-flex align-items-start justify-content-start flex-column gap-3">
						{categoryImage?.data?.attributes?.url ? <div className="d-md-block d-none">
							<Image
								src={formatImageSrc(categoryImage?.data?.attributes?.url)}
								style={{borderRadius: "16px", height: "420px", width: "300px"}}
								height={420}
								layout="fixed"
								objectFit="cover"
								width={300} />
						</div> : null}
						{categoryImageMobile?.data?.attributes?.url || categoryImage?.data?.attributes?.url ? <div className="d-md-none d-block">
							<Image
								src={formatImageSrc(categoryImageMobile?.data?.attributes?.url ? categoryImageMobile?.data?.attributes?.url : categoryImage?.data?.attributes?.url)}
								style={{
									borderRadius: "16px",
									height: "208px",
									width: "208px"
								}}
								objectFit="cover"
								height={208}
								layout="fixed"
								width={208} />
						</div> : null}
						<div className="d-flex align-items-start justify-content-start flex-column gap-1">
							<Typography variant="bodySmBold"
								className="brandworld-typography-title ">{title}</Typography>
							<Typography variant="bodySm"
								className="brandworld-typography-subtitle ">{subTitle}</Typography>
						</div>
					</div>
					<Button onClick={() => handleMagnetBtnClick(type, categorySlug, href)}
						label={t(categoryBtnCta)}
						isNoUppercase
						style={{marginTop: "1rem"}}
						fontSizeSmall
						textColor="#fff"
						bgColor={brandWorld.buttonsBackgroundColor} />
				</div>) : null}
		</div>
	)
}

export default BrandWorldCategories
